import _ from "lodash";
import {
  ASSESSMENT_TYPE_WORKSHEET,
  ASSESSMENT_TYPE_QUICK_TASK,
  LEARNING_ENGAGEMENT,
  GROUP_TYPE_WORKSHEET,
  AI_TUTOR,
  ASSESSMENT,
} from "Constants/stringConstants";

export const RESOURCES_KEY = "RESOURCES";

export const getGroupOrAssessmentTypes = _.memoize(
  ({ selectedAssessmentTypes }) => {
    const groupTypes = _.map(selectedAssessmentTypes, type => {
      switch (type) {
        case "qt":
        case ASSESSMENT_TYPE_QUICK_TASK:
          return ASSESSMENT_TYPE_QUICK_TASK;
        case "le":
        case LEARNING_ENGAGEMENT:
          return LEARNING_ENGAGEMENT;
        case ASSESSMENT_TYPE_WORKSHEET:
          return GROUP_TYPE_WORKSHEET;
        case "ai_tutor":
          return AI_TUTOR;
        default:
          return ASSESSMENT;
      }
    });
    return {
      assessmentTypes: undefined,
      groupTypes,
    };
  },
  params => JSON.stringify(params)
);
